<template>
    <div
        class="relative z-50 transition-all"
        :class="{'hidden': !showMobileMenu}"
        role="dialog"
        aria-modal="true"
    >
        <div @click="dismissHandler" class="fixed inset-0 z-40 flex">
            <div ref="mobileFilterDrawer" class="relative ml-auto flex h-full w-full max-w-xs flex-col overflow-y-auto bg-white py-4 pb-12 shadow-xl">
                <div class="flex items-center justify-between px-4">
                    <h2 class="text-lg font-medium text-gray-900">Filters</h2>
                    <button
                        @click="toggleMobileMenu"
                        type="button"
                        class="-mr-2 flex h-10 w-10 items-center justify-center rounded-md bg-white p-2 text-gray-400"
                    >
                        <span class="sr-only">Close menu</span>
                        <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                             aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <!-- Filters -->
                <form class="mt-4">
                    <FormFieldFilterGroupMobile
                        :condensed="false"
                        v-for="filter in filters"
                        :key="filter.field"
                        v-on:input="handleInput(filter.field, $event)"
                        :label="filter.name"
                        :name="`song-filter-${filter.name}`"
                        :value="filter.currentValue"
                        :items="filter.values.map(value => ({
                            value,
                            text: value,
                        }))"
                    >
                    </FormFieldFilterGroupMobile>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ContainerFilterDrawer',
    props: {
        // State
        showMobileMenu: {required: true},
        filters: {required: true},

        // Methods
        updateFilterCurrentValue: {required: true},
        toggleMobileMenu: {required: true},
        setShowMobileMenu: {required: true},
    },
    methods: {
        dismissHandler (event) {
            if (!this.$refs.mobileFilterDrawer.contains(event.target)) this.setShowMobileMenu(false);
        },
        handleInput (field, {name, value}) {
            return this.updateFilterCurrentValue({field, name, value});
        },
    }
};
</script>
